import { Dependency } from './dependency'
import { DEPENDENCY_UPDATE_EVENT } from './events'

const FORMS = new Map()

export class Form {
  // defaults
  dependencies = []
  state = {}

  constructor(formElement) {
    this.formElement = formElement
    this.state = this._getFormState()

    // If there are dependencies then initialize them and start listening to them
    if (this.state?.dependencies?.length) {
      this.dependencies = Dependency.fromList(this.state.dependencies, this)
      this._listenForInputTrackingDependencyChanges()
    }
  }

  addEventListener(type, listener) {
    this.formElement.addEventListener(type, listener)
    return () => this.formElement.removeEventListener(type, listener)
  }

  dispatchEvent(type, payload) {
    const event = new CustomEvent(type, { detail: payload, bubbles: true, cancelable: true })
    this.formElement.dispatchEvent(event)
  }

  _listenForInputTrackingDependencyChanges() {
    if (this.listeningForInputDependencyChanges === true) return
    const trackingFieldNames = this.dependencies.map(dep => dep.trackingFieldName)

    const triggerEvent = (event, eventType) => {
      const target = event.target

      if (!target.matches('input, textarea, select')) return
      if (!trackingFieldNames.includes(target.name)) return

      this.dispatchEvent(DEPENDENCY_UPDATE_EVENT, { targetName: target.name, eventType })
    }

    this.addEventListener('input', event => triggerEvent(event, 'input'))
    this.addEventListener('change', event => triggerEvent(event, 'change'))

    this.listeningForInputDependencyChanges = true
  }

  _getFormState() {
    const script = this.formElement.querySelector('script.js-c-form-state')
    if (!script) return undefined
    return JSON.parse(script.textContent)
  }
}

export function useForm(formElement) {
  if (!formElement) throw new Error('Missing form element')
  // Important to return here so the listeners don't get re-added
  if (FORMS.get(formElement)) return FORMS.get(formElement)

  const form = new Form(formElement)
  FORMS.set(formElement, form)

  return form
}
